// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2D4gc","large":"styles_large__UsVit"};